export const environment = {
  production: true,
  amplitudeKey: '14b77d0e4cf877bd8af0601bc586c127',
  sentryDSN:
    'https://44c5078ff5de4ca9b8b05dde15d54abf@o121681.ingest.sentry.io/6506282',
  sentryAuthToken:
    'fc73bc6f01330509328d2782198942b47482d92f121313447b087aa827612951',
  paymentBindingLink: 'https://autopass.app.link/cXQpzPUZf1b',
  newPlateLink: 'https://autopass.app.link/rrkLAV9UbZb',
};
